import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { subscribeToCouponList, SubscribeToListApiParameter } from "@SupplyLand/Services/EmailService";

export interface SubscribeParameter {
    email: string;
    onSuccess?: () => void;
}

type HandlerType = ApiHandlerDiscreteParameter<SubscribeParameter, SubscribeToListApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { emailAddress: props.parameter.email };
};

export const SendDataToApi: HandlerType = async props => {
    await subscribeToCouponList(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];
const couponSubscribe = createHandlerChainRunner(chain, "CouponSubscribeHandler");
export default couponSubscribe;
